import React from "react";
import { MarkdownPage } from "./MarkdownPage";

export const AuthAzurePage = () => (
  <MarkdownPage file="AuthAzure.md" />
);
